module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "pa-0"
  }, [_c('v-row', {
    staticClass: "row"
  }, [_c('v-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('upload-media', {
    attrs: {
      "accept": 'video/*|image/*',
      "listMedia": _vm.media
    },
    on: {
      "change": _vm.mediaChanged
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-248ba8b7"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/scoped/post/StoryForm.vue
// module id = 2041
// module chunks = 0